export const MAX_ITEMS_IN_CAROUSEL = 5

export const getSlidesToShow = (quantity, variants) => Math.min(variants.length, quantity)
